module.exports = __webpack_public_path__ + "img/Rectangle.6cffee70.png";